export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-2">
            <div className="text-xs font-bold tracking-widest text-cyan-500 mb-4">
              WHO WE ARE
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Protecting Privacy Since Day One
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8 text-base">
              DISTRIEM LTDA is dedicated to providing cutting-edge VPN solutions that safeguard your digital presence. We believe privacy is a fundamental right, and our mission is to make secure internet access available to everyone, everywhere.
            </p>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-cyan-500 text-lg"></i>
                </div>
                <span className="text-sm text-gray-700">Pereira, Colombia</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-cyan-500 text-lg"></i>
                </div>
                <a href="mailto:contact@distriemltda.com" className="text-sm text-gray-700 hover:text-cyan-500 transition-colors">
                  contact@distriemltda.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-cyan-500 text-lg"></i>
                </div>
                <a href="tel:+16507302658" className="text-sm text-gray-700 hover:text-cyan-500 transition-colors">
                  +1 650 730 2658
                </a>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-600 to-blue-600"></div>
              <img 
                src="https://public.readdy.ai/ai/img_res/74f635a5e9f11ee3f71dac0151a04d3f.jpg" 
                alt="VPN Network Security" 
                className="relative w-full h-96 object-cover mix-blend-overlay opacity-60"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center text-white p-8">
                  <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center border-2 border-white/30">
                    <i className="ri-shield-check-line text-5xl"></i>
                  </div>
                  <h3 className="text-3xl font-bold mb-3">Your Trust, Our Priority</h3>
                  <p className="text-white/80 text-sm max-w-md mx-auto">
                    Built with transparency and security at the core of everything we do
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
